// extracted by mini-css-extract-plugin
module.exports = {"categories":"style_categories__3VXS4","title":"style_title__3BY1a","sub-title":"style_sub-title__29lKj"};